
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'
import parseDate from 'utils/parseDate'
import findIndex from 'lodash/findIndex'
import slice from 'lodash/slice'
import get from 'lodash/get'
import set from 'lodash/set'

export const INTEGRATIONS = loadTypes('INTEGRATIONS')
export const INTEGRATIONS_ADD = loadTypes('INTEGRATIONS_ADD')
export const INTEGRATIONS_REMOVE = loadTypes('INTEGRATIONS_REMOVE')
export const INTEGRATIONS_CHANNEL_COSTS = loadTypes('INTEGRATIONS_CHANNEL_COSTS')
export const INTEGRATIONS_MARK_AS_CONNECTED = 'INTEGRATIONS_MARK_AS_CONNECTED'
export const INTEGRATION_DETAILS = loadTypes('INTEGRATION_DETAILS')

function integrationCostsReducer(state = {}, integrationCosts) {
  return {
    ...state,
    ...Object.keys(integrationCosts).reduce((acc, channelId) => {
      acc[channelId] = integrationCosts[channelId]
      return acc
    }, {})
  }
}

function processIntegrationCosts(request, response) {
  const integrationId = request.queryParams['filter[integration]']

  return {
    [integrationId]: response.map(item => {
      return {
        cost: item['cost:total'],
        day: parseDate(item.day)
      }
    })
  }
}

function processIntegrations(request, response) {
  if (!response) return null

  return Object.keys(response)
    .reduce((acc, key) => acc.concat(response[key].filter(i => i.connected).map(i => {
      const {dv_channel: dvChannel, dv_chgroup: dvChgroup} = get(i, 'costConfig.channel', {})

      if (dvChannel && dvChgroup) {
        set(i, 'costConfig.channel.channelGroupId', dvChgroup)
        set(i, 'costConfig.channel.channelId', dvChannel)
      }

      return i
    })), [])
}

function processIntegrationUpdate(integrations, request, response) {
  const integrationId = request.queryParams['integrationId']
  const integrationIndex = findIndex(integrations, i => i.id === integrationId)
  const integration = integrations[integrationIndex]
  const apiIntergations = ['google', 'facebook', 'bing', 'criteo']

  if (!integration) return integrations

  if (integration.serviceId === 'google-spreadsheet') {
    integration.costConfig = {
      ...integration.costConfig,
      link: response.spreadsheetUrl
    }
  } else if (apiIntergations.includes(integration.serviceId) && response && response.length) {
    integration.costConfig = {
      ...integration.costConfig,
      accounts: response.map(item => ({
        id: item.id || item.Id,
        name: item.name || item.Name
      }))
    }
  }

  return [...slice(integrations, 0, integrationIndex), integration, ...slice(integrations, integrationIndex + 1)]
}

const initialState = {
  integrationCosts: null,
  connectedIntegrations: [],

  integrations: null,
  isIntegrationsFetching: false,

  isIntegrationDeleting: null,

  isIntegrationCostsFetching: false,
  isIntegrationCostsFetchingErrorMessage: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case INTEGRATIONS.REQUEST:
      return {
        ...state,
        isIntegrationsFetching: true
      }

    case INTEGRATIONS.SUCCESS:
      return {
        ...state,
        integrations: processIntegrations(action.request, action.response),
        isIntegrationsFetching: false
      }

    case INTEGRATIONS.FAILURE:
      return {
        ...state,
        isIntegrationsFetching: false
      }

    case INTEGRATIONS_CHANNEL_COSTS.REQUEST:
      return {
        ...state,
        isIntegrationCostsFetching: true
      }

    case INTEGRATIONS_CHANNEL_COSTS.SUCCESS:
      return {
        ...state,
        isIntegrationCostsFetching: false,
        integrationCosts: integrationCostsReducer(
          state.integrationCosts,
          processIntegrationCosts(action.request, action.response)
        )
      }

    case INTEGRATIONS_CHANNEL_COSTS.FAILURE:
      return {
        ...state,
        isIntegrationCostsFetching: false,
        isIntegrationCostsFetchingErrorMessage: action.message
      }

    case INTEGRATIONS_REMOVE.REQUEST:
      return {
        ...state,
        isIntegrationDeleting: true
      }

    case INTEGRATIONS_REMOVE.SUCCESS:
      return {
        ...state,
        isIntegrationDeleting: false
      }

    case INTEGRATIONS_REMOVE.FAILURE:
      return {
        ...state,
        isIntegrationDeleting: false
      }

    case INTEGRATION_DETAILS.REQUEST:
      return {
        ...state,
        isIntegrationFetching: true
      }

    case INTEGRATION_DETAILS.SUCCESS:
      return {
        ...state,
        isIntegrationFetching: false,
        integrations: processIntegrationUpdate(state.integrations, action.request, action.response)
      }

    case INTEGRATION_DETAILS.FAILURE:
      return {
        ...state,
        isIntegrationFetching: false
      }

    case INTEGRATIONS_MARK_AS_CONNECTED:
      return {
        ...state,
        connectedIntegrations: state.connectedIntegrations.concat(action.serviceId)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/integrations/index.js